<template>
  <div class="ordListInfo">
    <div v-if="deliveryData.length === 0" style="color: grey">暂无配送信息</div>
    <div v-for="(delivery, index) in deliveryData" :key="delivery.sid">
      <el-card class="box-card bcGrey marginBottom10">
        <el-collapse v-model="activeNames" accordion>
          <el-collapse-item :name="(index + 1) + ''">
            <template slot="title">
              <div class="flex directionColumn padding10">
                <div >[{{ delivery.logisticName }}]第{{ index + 1 }}次下单</div>
                <div  class="fs11 C86909c">状态: {{ delivery.statusName }} · {{ delivery.ordDeliveryDetails[delivery.ordDeliveryDetails.length - 1].stime }} · {{ delivery.sdeliveryCost / 100 }}元·单号：{{ delivery.cdelivery }}</div>
                <div  class="fs11 C86909c">取货码:{{ delivery.srandomCode }}</div>
                <div  class="fs11 C86909c">备注:{{ delivery.sremark }}</div>
                <div>
                  <el-button v-if="[1, 2, 3, 4, 5, 7].includes(delivery.bstatus) && (delivery.cplat === 'elpt' || delivery.cplat === 'mtpt')" size="mini" @click="handleDeliverySwitch(delivery.corderNo)">切换自配送</el-button>&nbsp;
                  <el-button v-if="[1, 2, 3, 4, 5, 7].includes(delivery.bstatus) && (delivery.cplat === 'elpt')" size="mini" @click="handleDeliveryCancelCall(delivery.corderNo)">取消呼叫</el-button>&nbsp;
                  <el-button v-if="[1, 2, 3, 4, 5].includes(delivery.bstatus) && delivery.cplat !== 'elpt' && delivery.cplat !== 'mtpt'" size="mini" @click="handleDeliveryCancel(delivery.sid)">取消配送</el-button>&nbsp;
                  <el-button v-if="[3, 4, 5].includes(delivery.bstatus)" size="mini" @click="showRideMap(delivery.sid)">查看位置</el-button>&nbsp;
                  <el-button size="mini" @click="showLocationMap(delivery.sid)">查看轨迹</el-button>&nbsp;
                  <el-button size="mini" @click="handleMockArrive(delivery.sid)">模拟到店</el-button>&nbsp;
                  <el-button v-if="delivery.bstatus === 2" size="mini" @click="openAddTip(delivery.sid)">加小费</el-button>
                  <el-button size="mini" @click="handleGetWeather(delivery.sreceiverLongitude, delivery.sreceiverLatitude)">查询天气</el-button>
                </div>
              </div>
            </template>
            <div class="marginLeft10">
              <el-timeline class="marginTop10" :reverse="false">
                <el-timeline-item v-for="info in delivery.ordDeliveryDetails" :key="info.sid" :hide-timestamp="true" :timestamp="info.tcreate">
                  <div>{{ info.stitle }} · {{ info.stime }}</div>
                  <div class="fs11 C86909c">
                    {{ info.sremark }}
                  </div>
                  <div v-if="info.sdeliveryName" class="C86909c">
                    <div class="fs11">配送员：{{ info.sdeliveryName }}</div>
                    <div class="fs11">
                      联系方式：<a class="purple fs11" @click="callPhone(info.sdeliveryPhone)">{{ info.sdeliveryPhone }}</a>
                    </div>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-card>
    </div>
    <el-dialog v-if="rideLocationDialogVisible" class="elDialog" :close-on-click-modal="false" title="骑手位置" :visible.sync="rideLocationDialogVisible" width="800px" append-to-body>
      <getRideLocation v-if="rideLocationDialogVisible" :delivery-id="deliveryId" />
    </el-dialog>
    <el-dialog v-if="locationDialogVisible" class="elDialog" :close-on-click-modal="false" title="订单履约轨迹" :visible.sync="locationDialogVisible" width="800px" append-to-body>
      <getLocation v-if="locationDialogVisible" :delivery-id="deliveryId" />
    </el-dialog>
    <el-dialog class="elDialog" :close-on-click-modal="false" title="追加小费" :visible.sync="addTipDialogVisible" width="400px" append-to-body>
      <div class="flex marginBottom10">
        <div class="flex alignItemsCenter marginRight10">调度费用:</div>
        <el-select v-model="tip" placeholder="请选择追加金额">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <el-row type="flex" justify="end">
        <el-button type="primary" plain @click="addTipDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTip">确 认</el-button>
      </el-row>
    </el-dialog>
    <el-dialog class="elDialog" :close-on-click-modal="false" title="取消" :visible.sync="cancelDialogVisible" width="400px" append-to-body>
      <div class="flex marginBottom10">
        <div class="flex alignItemsCenter marginRight10">取消原因:</div>
        <el-select v-model="reasonCode" placeholder="请选择取消原因" @click="handleChangeCancelReason">
          <el-option v-for="item in mtzbCancelReason" :key="item.code" :label="item.reason" :value="item.code"></el-option>
        </el-select>
        <div class="flex alignItemsCenter marginRight10">{{ detailContent }}</div>
      </div>
      <el-row type="flex" justify="end">
        <el-button type="primary" plain @click="cancelDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCancelMtzb">确 认</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import getRideLocation from "@/views/order/getRideLocation.vue";
import getLocation from "@/views/order/getLocation.vue";
import deliveryTip from "@/utils/deliveryTip.js";
export default {
  name: "OrderDelivery",
  components: {
    getRideLocation,
    getLocation,
  },
  props: {
    orderId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      deliveryId: null,
      rideLocationDialogVisible: false,
      locationDialogVisible: false,
      addTipDialogVisible: false,
      cancelDialogVisible: false,
      tip: "",
      deliveryData: [],
      options: deliveryTip,
      reasonCode: "",
      detailContent: "",
      mtzbCancelReason: [],
      activeNames: ["1", "2", "3"],
    };
  },
  mounted() {
    this.handleInit();
  },
  methods: {
    handleInit() {
      this.topsAjax.get(`${this.baseUrls.ordDelivery}/queryList`, { rOrder: this.orderId }).then((response) => {
        this.deliveryData = response;
      });
    },
    handleChangeCancelReason() {
      for (let i = 0; i < this.mtzbCancelReason.length; i++) {
        if (this.reasonCode === this.mtzbCancelReason[i].code) {
          this.detailContent = this.mtzbCancelReason[i].content;
        }
      }
    },
    handleGetWeather(lng, lat) {
      this.topsAjax.get(`${this.baseUrls.xinzhi}/weather`, { lng, lat }).then((response) => {
        this.$alert('天气：' + response.text + "，湿度：" + response.humidity + "%", '天气信息', {
          confirmButtonText: '确定'
        });
      });
    },
    showRideMap(deliveryId) {
      this.deliveryId = deliveryId;
      this.rideLocationDialogVisible = true;
    },
    showLocationMap(deliveryId) {
      this.deliveryId = deliveryId;
      this.locationDialogVisible = true;
    },
    openAddTip(deliveryId) {
      this.deliveryId = deliveryId;
      this.addTipDialogVisible = true;
    },
    addTip() {
      this.topsAjax.post(`${this.baseUrls.ordDelivery}/addTip`, { deliveryId: this.deliveryId, tip: this.tip }).then((response) => {
        this.$message.success("成功");
        this.$emit("handleConfirm");
      });
    },
    handleDeliverySwitch(orderNo) {
      this.topsAjax.post(`${this.baseUrls.third}/orderSwitchself`, { orderNo }).then(() => {
        this.$message.success("切换成功");
        this.$emit("handleConfirm");
      });
    },
    handleDeliveryCancelCall(orderNo) {
      this.topsAjax.post(`${this.baseUrls.third}/cancelDelivery`, { orderNo }).then(() => {
        this.$message.success("取消成功");
        this.$emit("handleConfirm");
      });
    },
    handleDeliveryCancel(deliveryId) {
      this.deliveryId = deliveryId;
      this.topsAjax.get(`${this.baseUrls.ordDelivery}/queryCancelReason`, { sid: deliveryId }).then(response => {
        this.mtzbCancelReason = response;
        this.cancelDialogVisible = true;
      });
    },
    handleCancelMtzb() {
      this.topsAjax.post(`${this.baseUrls.ordDelivery}/cancel`, { deliveryId: this.deliveryId, reasonCode: this.reasonCode, detailContent: this.detailContent  }).then(() => {
        this.$message.success("取消成功");
        this.$emit("handleConfirm");
        this.cancelDialogVisible = false;
      });
    },
    handleMockArrive(deliveryId) {
      this.topsAjax.post(`${this.baseUrls.platUser}/mockArrive`, { deliveryId }).then(() => {
        this.$message.success("操作成功");
      });
    },
    callPhone(toTel) {
      this.$confirm(`是否拨打[<span style="color: red;">${toTel}</span>]的电话？`, {
        dangerouslyUseHTMLString: true,
      }).then((_) => {
        let url = `${this.baseUrls.websocket}/call?phone=${toTel}`;
        let params = {};
        this.topsAjax.get(url, params).then(() => {
          this.$message.success("请在呼叫中心客户端确认应答。");
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-collapse-item__header {
  height: auto;
  line-height: 20px;
  background-color: rgb(247, 248, 250) !important;
}

.container {
  display: flex;
  flex: 1;
  flex-direction: column;

  &__body {
    flex: 1;
  }
}
.labelGray {
  .el-descriptions-item__label:not(.is-bordered-label) {
    color: #909399;
  }

  .el-descriptions-item__container .el-descriptions-item__content,
  .el-descriptions-item__container .el-descriptions-item__label {
    display: inline-flex;
    justify-content: flex-end;
    margin-right: 10px;
  }
}

.el-card__body,
.el-main {
  padding: 0;
}

::v-deep .el-collapse-item__wrap {
  background-color: rgb(247, 248, 250) !important;
}


::v-deep .el-collapse-item__content {
  padding-bottom: 0;
}

::v-deep .el-descriptions--medium:not(.is-bordered) .el-descriptions-item__cell {
  padding-top: 0;
}

.green {
  background-color: #60e722;
}

.center {
  display: flex;
  justify-content: center;
}

.circle {
  width: 25px; /* 圆的直径 */
  height: 25px; /* 圆的直径 */
  border-radius: 50%; /* 使元素成为圆形的关键属性 */
}

.layout {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
  margin-bottom: 5px;
}
</style>
<style lang="scss" scoped>
.red {
  background-color: gray;
}

.circular {
  border-radius: 50%;
}
</style>
